<template>
  <p class="tw:px-2 tw:mb-0">
    <i class="tw:i-fal-ellipsis tw:animate-beat" />
  </p>
</template>

<script setup>
</script>
